import { createAction } from '@reduxjs/toolkit';

export const checkClassAction = createAction('moodle/checkClassAction');
export const checkClassFlowAction = createAction('moodle/checkClassFlowAction');
export const errorAction = createAction('moodle/errorAction');
export const initAction = createAction('moodle/initAction');
export const initMoodleUserAction = createAction('moodle/initMoodleUserAction');
export const setMeetingHasNotStartedAction = createAction('moodle/setMeetingHasNotStartedAction');
export const successAction = createAction('moodle/successAction');
